import { Lock, LockOpen, UserRound } from "lucide-react";
import { StatusBadge, type StatusTone } from "@/components/ui/status-badge";
import type { LearnAccessLevel } from "@/features/learn/api";

/**
 * The per-lesson access chip of docs/35 §2 and §4.
 *
 * `StatusBadge` is the one chip treatment in this app (`AGENTS.md` rule 17), so
 * this is a tone and an icon per level and not a second pill. The tones say
 * open, open-with-an-account and paid, in that order, and the label comes from
 * the caller so the copy stays in `messages/`.
 */
const META: Record<LearnAccessLevel, { tone: StatusTone; icon: typeof Lock }> = {
  free: { tone: "success", icon: LockOpen },
  core: { tone: "info", icon: UserRound },
  pro: { tone: "brand", icon: Lock },
};

export function LearnAccessChip({
  level,
  label,
  className,
}: {
  level: LearnAccessLevel;
  label: string;
  className?: string;
}) {
  const meta = META[level];
  return <StatusBadge className={className} icon={meta.icon} label={label} tone={meta.tone} />;
}
